export const sidebarlinks = [
    {
        title: "Public Companies DB",
        route: "companies",
    },
    // {
    //     title: "Private Companies DB",
    //     route: "private-companies",
    // },
    // {
    //     title: "Economic Indicators",
    //     route: "macros",
    // },
    // {
    //     title: "Industry Statistics",
    //     route: "industries",
    // },
    // {
    //     title: "Industry Reports",
    //     route: "reports",
    // },
    // {
    //     title: "Leads DB",
    //     route: "contacts",
    // },
    // {
    //     title: "Talent DB",
    //     route: "talent",
    // },
    // {
    //     title: "Public Relations DB",
    //     route: "prdb",
    // },
    // {
    //     title: "Experts DB",
    //     route: "expertsdb",
    // },
    // // {
    // //     title: "Professionals DB",
    // //     route: "expertsdb",
    // // },
    // {
    //     title: "M&A DB",
    //     route: "mergers-acquisitions",
    // },
    // {
    //     title: "Investors DB",
    //     route: "investors",
    // },
    // {
    //     title: "Lenders DB",
    //     route: "lenders",
    // },
];
